function getQuickStartRepo(): string {
  const owner = process.env.GITHUB_QUICKSTART_REPO_OWNER || 'grft-dev'
  const repo = process.env.GITHUB_QUICKSTART_REPO || 'graftcode-quick-start-guide'
  return `${owner}/${repo}`
}

function getDocumentationRepo(): string {
  const owner = process.env.GITHUB_DOCS_REPO_OWNER || 'grft-dev'
  const repo = process.env.GITHUB_DOCS_REPO || 'graftcode-documentation'
  return `${owner}/${repo}`
}

function getGlossaryRepo(): string {
  const owner = process.env.GITHUB_GLOSSARY_REPO_OWNER || 'grft-dev'
  const repo = process.env.GITHUB_GLOSSARY_REPO || 'graftcode-glossary'
  return `${owner}/${repo}`
}

function getQuickStartBranch(): string {
  return process.env.GITHUB_QUICKSTART_REPO_BRANCH || 'main'
}

function getDocumentationBranch(): string {
  return process.env.GITHUB_DOCS_REPO_BRANCH || 'main'
}

function getGlossaryBranch(): string {
  return process.env.GITHUB_GLOSSARY_REPO_BRANCH || 'main'
}

export const GITHUB_API_BASE = 'https://api.github.com/repos'
export const GITHUB_RAW_BASE = 'https://raw.githubusercontent.com'
export const GITHUB_REPO_QUICK_START = getQuickStartRepo()
export const GITHUB_REPO_DOCUMENTATION = getDocumentationRepo()
export const GITHUB_REPO_GLOSSARY = getGlossaryRepo()
export const GITHUB_REPO = GITHUB_REPO_QUICK_START

export const GITHUB_REPOS = {
  QUICK_START: GITHUB_REPO_QUICK_START,
  DOCUMENTATION: GITHUB_REPO_DOCUMENTATION,
  GLOSSARY: GITHUB_REPO_GLOSSARY,
} as const

export function resolveBranch(branch: string | null, repo: string): string {
  if (branch !== null) return branch
  if (repo === GITHUB_REPO_DOCUMENTATION) return getDocumentationBranch()
  if (repo === GITHUB_REPO_GLOSSARY) return getGlossaryBranch()
  return getQuickStartBranch()
}

export const QUICK_START_LANGUAGE_PRIORITY: readonly string[] = [
  'react',
  'angular',
  'vue',
  'javascript',
  'typescript',
  'ts',
  'csharp',
  'cs',
  'dotnet',
  'fsharp',
  'fs',
  'python',
  'py',
  'go',
  'java',
  'kotlin',
  'groovy',
  'swift',
  'rust',
  'cpp',
  'c',
]
